// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$String from "../../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Currency from "../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Array from "../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as SlabDataVm from "../SlabDataVm.bs.js";
import * as Caml_format from "../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CurrencyMinor from "../../../../../../../library/data-source/country-currency/CurrencyMinor.bs.js";
import * as Date$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as ListUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ListUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";

function mapIntegerToDelta(value) {
  if (value === 0) {
    return ;
  } else {
    return value;
  }
}

function mapPaisaToDeltaRupee(value) {
  if (CurrencyMinor.fromBase(value) === 0) {
    return ;
  } else {
    return Caml_option.some(CurrencyMajorMinorMapper.baseToCurrency(value));
  }
}

function mapZonesToId(zones, zone_ids) {
  return List.map((function (z) {
                return z.description;
              }), List.filter(function (z) {
                    return List.exists((function (i) {
                                  return i === z.id;
                                }), zone_ids);
                  })(zones));
}

function mapClustersToId(clusters, cluster_ids) {
  return List.map((function (c) {
                return c.description;
              }), List.filter(function (c) {
                    return List.exists((function (i) {
                                  return i === c.id;
                                }), cluster_ids);
                  })(clusters));
}

function serializedSimpleBaseDetails(core_pricing, delta_details) {
  return {
          base_fare: {
            delta: mapPaisaToDeltaRupee(CurrencyMajorMinorMapper.currencyToBase(delta_details.base_fare_delta)),
            value: Currency.add(core_pricing.base_fare, delta_details.base_fare_delta)
          },
          free_duration: {
            delta: mapIntegerToDelta(delta_details.free_duration_delta),
            value: core_pricing.free_duration + delta_details.free_duration_delta | 0
          },
          waiting_rate: {
            delta: mapPaisaToDeltaRupee(CurrencyMajorMinorMapper.currencyToBase(delta_details.waiting_rate_per_min_delta)),
            value: Currency.add(core_pricing.waiting_rate, delta_details.waiting_rate_per_min_delta)
          },
          free_kms: {
            delta: mapIntegerToDelta(delta_details.free_kms_delta),
            value: core_pricing.free_kms + delta_details.free_kms_delta | 0
          },
          free_km_price_per_min: {
            delta: mapPaisaToDeltaRupee(CurrencyMajorMinorMapper.currencyToBase(delta_details.free_km_price_delta)),
            value: Currency.add(core_pricing.free_km_price_per_min, delta_details.free_km_price_delta)
          }
        };
}

function serializedAbBaseDetails(core_pricing, delta_details) {
  return {
          base_fare: {
            delta: mapPaisaToDeltaRupee(CurrencyMajorMinorMapper.currencyToBase(delta_details.base_fare_delta)),
            value: Currency.add(core_pricing.base_fare, delta_details.base_fare_delta)
          },
          free_duration: {
            delta: mapIntegerToDelta(delta_details.free_duration_delta),
            value: core_pricing.free_duration + delta_details.free_duration_delta | 0
          },
          waiting_rate: {
            delta: mapPaisaToDeltaRupee(CurrencyMajorMinorMapper.currencyToBase(delta_details.waiting_rate_per_min_delta)),
            value: Currency.add(core_pricing.waiting_rate, delta_details.waiting_rate_per_min_delta)
          },
          free_kms: {
            delta: mapIntegerToDelta(delta_details.free_kms_delta),
            value: core_pricing.free_kms + delta_details.free_kms_delta | 0
          },
          free_km_price_per_min: {
            delta: mapPaisaToDeltaRupee(CurrencyMajorMinorMapper.currencyToBase(delta_details.free_km_price_delta)),
            value: Currency.add(core_pricing.free_km_price_per_min, delta_details.free_km_price_delta)
          }
        };
}

function getRepeatDaysString(days) {
  if (days !== undefined && List.length(days) !== 7) {
    return ListUtils$Catalyst.toString(days, (function (a) {
                  return $$String.sub(a, 0, 3);
                }), undefined, undefined);
  } else {
    return "All";
  }
}

function serializeZoneAndClusterData(descriptions) {
  if (!descriptions) {
    return {
            content: "Not Applicable",
            tool_tip_content: undefined
          };
  }
  var match = descriptions.tl;
  var a = descriptions.hd;
  if (!match) {
    return {
            content: a,
            tool_tip_content: undefined
          };
  }
  var tail = match.tl;
  var b = match.hd;
  if (tail) {
    return {
            content: a + (", " + (b + ", ")),
            tool_tip_content: {
              content: ListUtils$Catalyst.toString(tail, (function (a) {
                      return a;
                    }), undefined, undefined),
              title: "+" + (String(List.length(tail)) + " more")
            }
          };
  } else {
    return {
            content: a + (", " + b),
            tool_tip_content: undefined
          };
  }
}

function serializeEligibilityRules(start_time, end_time, days, pickup_zone, pickup_cluster, drop_zone, drop_cluster, zones, clusters) {
  return {
          start_time: start_time,
          end_time: end_time,
          repeat_days: getRepeatDaysString(days ? days : undefined),
          pick_up_zone: pickup_zone !== undefined ? serializeZoneAndClusterData(mapZonesToId(zones, pickup_zone)) : ({
                content: "Not Applicable",
                tool_tip_content: undefined
              }),
          pick_up_cluster: pickup_cluster !== undefined ? serializeZoneAndClusterData(mapClustersToId(clusters, pickup_cluster)) : ({
                content: "Not Applicable",
                tool_tip_content: undefined
              }),
          drop_zone: drop_zone !== undefined ? serializeZoneAndClusterData(mapZonesToId(zones, drop_zone)) : ({
                content: "Not Applicable",
                tool_tip_content: undefined
              }),
          drop_cluster: drop_cluster !== undefined ? serializeZoneAndClusterData(mapClustersToId(clusters, drop_cluster)) : ({
                content: "Not Applicable",
                tool_tip_content: undefined
              })
        };
}

function getVm(modification_data, core_pricing, creator_name, zones, clusters) {
  if (modification_data.TAG === /* AB */0) {
    var eligiblity_rules = modification_data.eligiblity_rules;
    var slab_details_control = modification_data.slab_details_control;
    var slab_details_test = modification_data.slab_details_test;
    var base_details_control = modification_data.base_details_control;
    var base_details_test = modification_data.base_details_test;
    var key_details = modification_data.key_details;
    var ids = Belt_Array.slice(key_details.test_ids, 0, Caml_format.caml_int_of_string(key_details.test_group));
    var ids$1 = Belt_Array.slice(key_details.test_ids, 0, Caml_format.caml_int_of_string(key_details.test_group));
    return {
            external_id: "N/A",
            name: key_details.name,
            vehicle_name: core_pricing.vehicle_name,
            region: core_pricing.region_name,
            status: /* Pending */1,
            created_on: Timestamp$Catalyst.toString(Timestamp$Catalyst.now(undefined), "DD/MM/yyyy"),
            created_by: creator_name,
            core_pricing_name: core_pricing.campaign_name,
            start_date: key_details.start_date,
            end_date: key_details.end_date,
            base_details: Belt_Array.mapWithIndex(ids, (function (index, id_bucket) {
                    return {
                            TAG: /* AB */0,
                            test_details: serializedAbBaseDetails(core_pricing, Belt_Array.getExn(base_details_test, index)),
                            control_details: serializedAbBaseDetails(core_pricing, base_details_control),
                            test_gr_customer_ids: {
                              start: Caml_format.caml_int_of_string(id_bucket.start),
                              end: Caml_format.caml_int_of_string(id_bucket.end)
                            }
                          };
                  })),
            slabs: Belt_Array.mapWithIndex(ids$1, (function (index, id_bucket) {
                    return {
                            TAG: /* AB */0,
                            test_details: SlabDataVm.getVm(core_pricing.free_kms + Belt_Array.getExn(base_details_test, index).free_kms_delta | 0, Belt_Array.getExn(slab_details_test, index)),
                            control_details: SlabDataVm.getVm(core_pricing.free_kms + base_details_control.free_kms_delta | 0, slab_details_control),
                            test_gr_customer_ids: {
                              start: Caml_format.caml_int_of_string(id_bucket.start),
                              end: Caml_format.caml_int_of_string(id_bucket.end)
                            }
                          };
                  })),
            eligibility_rules: serializeEligibilityRules(eligiblity_rules.start_time, eligiblity_rules.end_time, eligiblity_rules.days, eligiblity_rules.pickup_zone, eligiblity_rules.pickup_cluster, eligiblity_rules.drop_zone, eligiblity_rules.drop_cluster, zones, clusters)
          };
  }
  var eligiblity_rules$1 = modification_data.eligiblity_rules;
  var base_details = modification_data.base_details;
  var key_details$1 = modification_data.key_details;
  return {
          external_id: "N/A",
          name: key_details$1.name,
          vehicle_name: core_pricing.vehicle_name,
          region: core_pricing.region_name,
          status: /* Pending */1,
          created_on: Date$Catalyst.toString("DD/MM/yyyy", Date$Catalyst.now(undefined)),
          created_by: creator_name,
          core_pricing_name: core_pricing.campaign_name,
          start_date: key_details$1.start_date,
          end_date: key_details$1.end_date,
          base_details: [{
              TAG: /* Simple */1,
              _0: serializedSimpleBaseDetails(core_pricing, base_details)
            }],
          slabs: [{
              TAG: /* Simple */1,
              _0: SlabDataVm.getVm(core_pricing.free_kms + base_details.free_kms_delta | 0, modification_data.slab_details)
            }],
          eligibility_rules: serializeEligibilityRules(eligiblity_rules$1.start_time, eligiblity_rules$1.end_time, eligiblity_rules$1.days, eligiblity_rules$1.pickup_zone, eligiblity_rules$1.pickup_cluster, eligiblity_rules$1.drop_zone, eligiblity_rules$1.drop_cluster, zones, clusters)
        };
}

export {
  getVm ,
  serializedAbBaseDetails ,
  
}
/* Date-Catalyst Not a pure module */
